import { Message } from "primereact/message";

import {
  Calendar,
  ConfirmDialog,
  Dialog,
  DialogFooter,
  DialogHeader,
  Dropdown,
  FormField,
} from "@/ds";
import { CampoDecimal } from "@/shared/components";
import {
  COMPETENCIA_LABEL,
  COMPETENCIA_MINIMA,
  COMPETENCIA_PLACEHOLDER,
  COTACAO_DICA,
  COTACAO_LABEL,
  MOEDA_BUSCA_PLACEHOLDER,
  MOEDA_LABEL,
  MOEDA_PLACEHOLDER,
  NOVA_COTACAO_TITULO,
  SALVAR_LABEL,
} from "./nova-cotacao-dialog.constants";
import styles from "./nova-cotacao-dialog.module.scss";
import type { NovaCotacaoDialogViewModel } from "./types-nova-cotacao-dialog";

const RODAPE_DIALOGO = { footer: { className: styles.dialogoRodape } };
const PAINEL = { panel: { className: styles.painel } };

export function NovaCotacaoDialogView({
  formId,
  competencia,
  moeda,
  cotacao,
  isSubmitting,
  submitError,
  enviar,
  cancelar,
  descarte,
}: NovaCotacaoDialogViewModel) {
  return (
    <>
      <Dialog
        visible
        size="md"
        className={styles.dialogo}
        contentClassName={styles.corpo}
        onHide={cancelar}
        locked={isSubmitting}
        focusOnShow={false}
        header={<DialogHeader title={NOVA_COTACAO_TITULO} />}
        pt={RODAPE_DIALOGO}
        footer={
          <DialogFooter
            className={styles.rodape}
            confirmLabel={SALVAR_LABEL}
            formId={formId}
            loading={isSubmitting}
            locked={isSubmitting}
            onCancel={cancelar}
            testId="nova-cotacao"
          />
        }
        data-testid="nova-cotacao-dialog"
      >
        <form id={formId} className={styles.form} onSubmit={enviar} noValidate>
          <div className={styles.campos}>
            <FormField.Root required error={competencia.erro}>
              <FormField.Label>{COMPETENCIA_LABEL}</FormField.Label>
              <FormField.Control>
                <Calendar
                  appendTo={document.body}
                  className="p-calendar-icone-dentro"
                  view="month"
                  dateFormat="mm/yy"
                  placeholder={COMPETENCIA_PLACEHOLDER}
                  minDate={COMPETENCIA_MINIMA}
                  showButtonBar={false}
                  value={competencia.valor}
                  onChange={(evento) => competencia.escolher(evento.value ?? null)}
                  disabled={isSubmitting}
                  data-testid="nova-cotacao-competencia"
                />
              </FormField.Control>
              <FormField.Error />
            </FormField.Root>
            <FormField.Root required error={moeda.erro}>
              <FormField.Label>{MOEDA_LABEL}</FormField.Label>
              <FormField.Control>
                <Dropdown
                  appendTo="self"
                  pt={PAINEL}
                  value={moeda.valor}
                  options={moeda.opcoes}
                  placeholder={MOEDA_PLACEHOLDER}
                  filter
                  filterPlaceholder={MOEDA_BUSCA_PLACEHOLDER}
                  showClear={false}
                  disabled={isSubmitting}
                  onChange={(evento) => moeda.escolher(evento.value ?? null)}
                  data-testid="nova-cotacao-moeda"
                />
              </FormField.Control>
              <FormField.Error />
            </FormField.Root>
            <div className={styles.cotacao}>
              <CampoDecimal
                label={COTACAO_LABEL}
                casas={2}
                required
                value={cotacao.valor}
                onChange={cotacao.digitar}
                error={cotacao.erro}
                disabled={isSubmitting}
                testId="nova-cotacao-cotacao"
              />
              <p className={styles.dica}>{COTACAO_DICA}</p>
            </div>
          </div>

          {submitError ? (
            <Message
              className="p-message-block"
              severity="error"
              text={submitError}
              data-testid="nova-cotacao-submit-error"
            />
          ) : null}
        </form>
      </Dialog>
      {descarte ? <ConfirmDialog {...descarte} /> : null}
    </>
  );
}
